import { render, staticRenderFns } from "./invest_qrcode99.vue?vue&type=template&id=2caae2f4&scoped=true&"
import script from "./invest_qrcode99.vue?vue&type=script&lang=js&"
export * from "./invest_qrcode99.vue?vue&type=script&lang=js&"
import style0 from "./invest_qrcode99.vue?vue&type=style&index=0&id=2caae2f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caae2f4",
  null
  
)

export default component.exports